import React from 'react';
export function TermsOfUsePage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-730">
      <div className="max-w-4xl mx-auto px-4 py-16" data-id="element-731">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8 md:p-12" data-id="element-732">
          <h1 className="text-4xl font-bold text-gray-900 mb-6" data-id="element-733">
            Terms of Use & Disclaimer
          </h1>

          <p className="text-gray-700 leading-relaxed mb-8" data-id="element-734">
            This website provides crypto-related news and information aggregated
            from various public and external sources. The content is offered
            solely for general informational purposes and does not constitute
            financial, investment, trading, legal, or tax advice.
          </p>

          <section className="mb-8" data-id="element-735">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-736">
              1. No Financial or Investment Advice
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-737">
              Nothing on this website should be treated as a recommendation to
              buy, sell, or hold any cryptocurrency or financial product. Users
              must conduct independent research and consult qualified
              professionals before making financial decisions.
            </p>
          </section>

          <section className="mb-8" data-id="element-738">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-739">
              2. Accuracy & Limitation of Liability
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-740">
              While we aim to provide accurate and up-to-date information, we
              make no guarantees about completeness, reliability, or accuracy.
              The use of this website and reliance on its content is strictly at
              your own risk. The website owners are not liable for losses,
              damages, or actions taken based on the information provided.
            </p>
          </section>

          <section className="mb-8" data-id="element-741">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-742">
              3. Third-Party Sources & External Links
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-743">
              Some content may link to or summarize third-party material. We do
              not control or endorse the content, operations, or policies of
              external sites and bear no responsibility for them.
            </p>
          </section>

          <section className="mb-8" data-id="element-744">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-745">
              4. Intellectual Property
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-746">
              All original content on this website is protected by applicable
              intellectual property laws. Content sourced from third parties
              remains the property of its respective owners.
            </p>
          </section>

          <section className="mb-8" data-id="element-747">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-748">
              5. User Responsibility
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-749">
              Cryptocurrency markets are highly volatile. By using this website,
              you agree that you alone are responsible for evaluating risks and
              verifying information before taking action.
            </p>
          </section>

          <section className="mb-8" data-id="element-750">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-751">
              6. Changes to These Terms
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-752">
              We may update these Terms of Use from time to time. Continued use
              of the website indicates acceptance of any changes.
            </p>
          </section>

          <p className="text-gray-700 leading-relaxed mt-8 pt-8 border-t border-gray-200" data-id="element-753">
            If you do not agree with these terms, please discontinue use of the
            website.
          </p>
        </div>
      </div>
    </div>;
}